import React from 'react'
import { Link } from 'react-router-dom'

const getLinkCell = (cellData, targetField, linkField = 'id') => {
  const targetValue = cellData.row[targetField]
  const targetLink = cellData.row[linkField]

  return <Link to={targetLink}>{targetValue}</Link>
}

export default getLinkCell
